import React from 'react'

import { Dropdown } from '@fourthwall/components'

import { QuickActionsDropdownItem } from './components/QuickActionsDropdownItem/QuickActionsDropdownItem'
import { useQuickActions } from './hooks/useQuickActions'

type QuickActionsDropdownProps = {
  children: React.ReactNode
}

export const QuickActionsDropdown = ({ children }: QuickActionsDropdownProps) => {
  const { dropdownItems } = useQuickActions()

  if (!dropdownItems.length) return null

  return (
    <Dropdown
      content={dropdownItems.map(({ ...props }, index) => (
        <QuickActionsDropdownItem key={index} {...props} />
      ))}
      position="bottom-end"
      testid="QuickActionsDropdown"
    >
      {children}
    </Dropdown>
  )
}
